export class BaseService {
  /** @type {{prototype:any}} */
  _vue;

  constructor(Vue) {
    this._vue = Vue;
  }
}
